"use strict";

var _classCallCheck = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var stableSortBy = require("lodash.sortby");

var urlencoded = require("./urlencoded");

exports.implementation = /*#__PURE__*/function () {
  function URLSearchParamsImpl(constructorArgs, _ref) {
    var _ref$doNotStripQMark = _ref.doNotStripQMark,
        doNotStripQMark = _ref$doNotStripQMark === void 0 ? false : _ref$doNotStripQMark;

    _classCallCheck(this, URLSearchParamsImpl);

    var init = constructorArgs[0];
    this._list = [];
    this._url = null;

    if (!doNotStripQMark && typeof init === "string" && init[0] === "?") {
      init = init.slice(1);
    }

    if (Array.isArray(init)) {
      var _iterator = _createForOfIteratorHelper(init),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var pair = _step.value;

          if (pair.length !== 2) {
            throw new TypeError("Failed to construct 'URLSearchParams': parameter 1 sequence's element does not " + "contain exactly two elements.");
          }

          this._list.push([pair[0], pair[1]]);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    } else if (typeof init === "object" && Object.getPrototypeOf(init) === null) {
      for (var _i = 0, _Object$keys = Object.keys(init); _i < _Object$keys.length; _i++) {
        var name = _Object$keys[_i];
        var value = init[name];

        this._list.push([name, value]);
      }
    } else {
      this._list = urlencoded.parseUrlencoded(init);
    }
  }

  _createClass(URLSearchParamsImpl, [{
    key: "_updateSteps",
    value: function _updateSteps() {
      if (this._url !== null) {
        var query = urlencoded.serializeUrlencoded(this._list);

        if (query === "") {
          query = null;
        }

        this._url._url.query = query;
      }
    }
  }, {
    key: "append",
    value: function append(name, value) {
      this._list.push([name, value]);

      this._updateSteps();
    }
  }, {
    key: "delete",
    value: function _delete(name) {
      var i = 0;

      while (i < this._list.length) {
        if (this._list[i][0] === name) {
          this._list.splice(i, 1);
        } else {
          i++;
        }
      }

      this._updateSteps();
    }
  }, {
    key: "get",
    value: function get(name) {
      var _iterator2 = _createForOfIteratorHelper(this._list),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var tuple = _step2.value;

          if (tuple[0] === name) {
            return tuple[1];
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return null;
    }
  }, {
    key: "getAll",
    value: function getAll(name) {
      var output = [];

      var _iterator3 = _createForOfIteratorHelper(this._list),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var tuple = _step3.value;

          if (tuple[0] === name) {
            output.push(tuple[1]);
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return output;
    }
  }, {
    key: "has",
    value: function has(name) {
      var _iterator4 = _createForOfIteratorHelper(this._list),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var tuple = _step4.value;

          if (tuple[0] === name) {
            return true;
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      return false;
    }
  }, {
    key: "set",
    value: function set(name, value) {
      var found = false;
      var i = 0;

      while (i < this._list.length) {
        if (this._list[i][0] === name) {
          if (found) {
            this._list.splice(i, 1);
          } else {
            found = true;
            this._list[i][1] = value;
            i++;
          }
        } else {
          i++;
        }
      }

      if (!found) {
        this._list.push([name, value]);
      }

      this._updateSteps();
    }
  }, {
    key: "sort",
    value: function sort() {
      this._list = stableSortBy(this._list, [0]);

      this._updateSteps();
    }
  }, {
    key: Symbol.iterator,
    value: function value() {
      return this._list[Symbol.iterator]();
    }
  }, {
    key: "toString",
    value: function toString() {
      return urlencoded.serializeUrlencoded(this._list);
    }
  }]);

  return URLSearchParamsImpl;
}();